import { render } from "./B2B.vue?vue&type=template&id=037a1e02&scoped=true"
import script from "./B2B.vue?vue&type=script&lang=js"
export * from "./B2B.vue?vue&type=script&lang=js"

import "./B2B.vue?vue&type=style&index=0&id=037a1e02&scoped=true&lang=css"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-037a1e02"]])

export default __exports__